exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#history-credits .div-header{\n  background-color: #fcfcfc;\n  padding-bottom: 15px;\n  padding-top: 12px;\n  margin: 0px !important;\n}\n\n#table_history_credits{\n    padding: 8px;\n    width: 100%;\n}\n\n#table_history_credits{\n    border: 1px solid #f1f1f1;\n    background-color: #fafafa;\n    padding: 8px;\n}\n\n#table_history_credits td,#table_history_credits th{\n    padding: 8px;\n    border-bottom: 1px solid #e9ebeb;\n}\n#table_history_credits td:last-child{\n    width: 120px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/history-credits-dialog/history-credits-dialog.component.css
// module id = ../../../../../src/app/pages/history-credits-dialog/history-credits-dialog.component.css
// module chunks = main